import React from 'react';
import { StatusSummary, SalesStatus } from '../types';
import { SALES_STATUS_LABELS, SALES_STATUS_DOT_STYLES } from '../stepLabels';

interface StatTileRowProps {
  summary: StatusSummary;
  activeStatus: string;
  onSelect: (status: SalesStatus) => void;
}

const TILE_ORDER: SalesStatus[] = ['not_contacted', 'contacted', 'follow_up', 'not_interested'];

const StatTileRow: React.FC<StatTileRowProps> = ({ summary, activeStatus, onSelect }) => {
  const total = TILE_ORDER.reduce((sum, key) => sum + (summary[key] || 0), 0);

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
      {TILE_ORDER.map((key) => {
        const count = summary[key] || 0;
        const pct = total > 0 ? Math.round((count / total) * 100) : 0;
        const isActive = activeStatus === key;
        return (
          <button
            key={key}
            onClick={() => onSelect(key)}
            className={`text-left bg-white rounded-lg p-4 transition-colors ${
              isActive ? 'border-2 border-gray-900' : 'border border-gray-100 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center gap-1.5 mb-2">
              <span className={`w-2 h-2 rounded-full ${SALES_STATUS_DOT_STYLES[key]}`} />
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                {SALES_STATUS_LABELS[key]}
              </span>
            </div>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-semibold text-gray-900">{count}</span>
              <span className="text-xs text-gray-400">{pct}%</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default StatTileRow;
